import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_SURVEYCONCEPT,
  DELETE_SURVEYCONCEPT,
  GET_SURVEYCONCEPTS,
  UPDATE_SURVEYCONCEPT,
  UPDATE_SURVEYCONCEPT_STATUS
} from "./actionTypes";

import {
  addSurveyConceptFail,
  addSurveyConceptSuccess,
  deleteSurveyConceptFail,
  deleteSurveyConceptSuccess,
  getSurveyConceptsFail,
  getSurveyConceptsSuccess,
  setState,
  updateSurveyConceptFail,
  updateSurveyConceptSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { surveyConcepts, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchSurveyConcepts({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, surveyConcepts, params.toString());
    yield put(setState(false));
    yield put(getSurveyConceptsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getSurveyConceptsFail(error));
  }
}

function* updateSurveyConcept({ payload: surveyConceptObj }) {
  try {
    const { id, recordStatus, ...rest } = surveyConceptObj;
    yield call(patchApiCall, `${surveyConcepts}/${id}`, rest);
    const response = yield call(getTable, `${surveyConcepts}/${surveyConceptObj.id}`);
    yield put(updateSurveyConceptSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateSurveyConceptFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateSurveyConceptStatus({ payload: surveyConceptObj }) {
  try {
    const { id } = surveyConceptObj;
    yield call(patchApiCall, `${surveyConcepts}/${updateStatus}/${id}`, { recordStatus: surveyConceptObj.recordStatus });
    const response = yield call(getTable, `${surveyConcepts}/${surveyConceptObj.id}`);
    yield put(updateSurveyConceptSuccess(response));
  } catch (error) {
    yield put(updateSurveyConceptFail(error));
  }
}

function* deleteSurveyConcept({ payload: surveyConceptObj }) {
  try {
    yield call(deleteApiCall, `${surveyConcepts}/${surveyConceptObj.id}`);
    yield put(deleteSurveyConceptSuccess(surveyConceptObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteSurveyConceptFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingSurveyConcept({ payload: surveyConcept }) {
  try {
    const response = yield call(postApiCall, surveyConcepts, surveyConcept);
    const responseDetails = yield call(getTable, `${surveyConcepts}/${response.id}`);
    yield put(addSurveyConceptSuccess(responseDetails));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addSurveyConceptFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* surveyConceptsSaga() {
  yield takeEvery(GET_SURVEYCONCEPTS, fetchSurveyConcepts);
  yield takeEvery(ADD_NEW_SURVEYCONCEPT, postingSurveyConcept);
  yield takeEvery(UPDATE_SURVEYCONCEPT, updateSurveyConcept);
  yield takeEvery(UPDATE_SURVEYCONCEPT_STATUS, updateSurveyConceptStatus);
  yield takeEvery(DELETE_SURVEYCONCEPT, deleteSurveyConcept);
}

export default surveyConceptsSaga;
